const INTER_FONT_FAMILY = [
  'Inter',
  '-apple-system',
  'Segoe UI',
  'Roboto',
  'Noto Sans',
  'Ubuntu',
  'Cantarell',
  'Helvetica Neue',
].join(', ');

/** @deprecated Prefer using the fontFamily token from @ardoq/design-tokens instead */
export const ARDOQ_DEFAULT_FONT_FAMILY = INTER_FONT_FAMILY;
